import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import {
  mediaLargeScreens,
  mediaMinL,
} from 'uiComponents/constants/customMedia'
import { FallbackWrapper } from 'uiComponents/molecules/ProductTile/FallbackSkeleton'
import { ProductTileSoldOutSelector } from 'uiComponents/molecules/ProductTile/ProductTileSoldOut'
import { ProductTileSelector } from '../ProductTile/ProductTile'

const ProductsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;

  ${ProductTileSelector}, ${ProductTileSoldOutSelector}, ${FallbackWrapper} {
    border-radius: 4px;
    margin: 0 0 40px 5px;
    width: calc(50% - 5px);

    @media ${mediaLargeScreens} {
      width: calc(33% - 5px);
    }

    @media ${mediaMinL} {
      margin-bottom: 60px;
    }
  }
`

interface Props {
  dataTestId?: string
  productTiles: ReactNode[]
  className?: string
}
const RecoProductGrid: FC<Props> = ({
  dataTestId,
  productTiles,
  className,
}) => {
  return (
    <ProductsContainer
      data-testid={dataTestId ? dataTestId : 'RecoProductGrid'}
      className={className}
    >
      {productTiles}
    </ProductsContainer>
  )
}

export default RecoProductGrid
